import React from 'react';
import { DateTime } from 'luxon';
import { getLoyaltyDescription } from '../../../helpers/utils';
import { usePager } from '../../../helpers/pagination';
import { CongratulationsRunner } from '../CongratulationsRunner';
import SideBar from '../../Common/SideBar';
import PageIndicator from '../../Common/PageIndicator';
import Row from './Row';
import SpotlightHeader from '../../Common/Header';
import './EmployeeLoyaltyLeaderboard.scss';
const getFormattedData = (data, metadata) => {
  var _metadata$boh_date_ra;
  const {
    timezone,
    last_updated
  } = data;
  const {
    boh_period,
    boh_date_range,
    results,
    boh_event_type
  } = metadata;
  const {
    endDate
  } = (_metadata$boh_date_ra = metadata.boh_date_range) !== null && _metadata$boh_date_ra !== void 0 ? _metadata$boh_date_ra : {};
  const description = getLoyaltyDescription(timezone, boh_event_type, boh_period, boh_date_range, last_updated);
  const employees = data.employees.slice(0, results);
  const topEmployeeName = employees[0].name;
  const showCongratulations = !!(boh_event_type === 'custom' && endDate) && DateTime.local().startOf('day') > DateTime.fromISO(endDate);
  const hide_poweredbyupshow = metadata.hide_poweredbyupshow;
  return {
    description,
    employees,
    topEmployeeName,
    showCongratulations,
    hide_poweredbyupshow
  };
};
const EmployeeLoyaltyLeaderboard = props => {
  const {
    data,
    metadata,
    text,
    duration,
    playing,
    bohStyle
  } = props;
  const {
    accent_color,
    title_color,
    title_font_family,
    text_accent_color,
    containerStyle,
    listHeaderRowStyle
  } = bohStyle;
  const {
    employees,
    topEmployeeName,
    description,
    showCongratulations,
    hide_poweredbyupshow
  } = getFormattedData(data, metadata);
  const [page, pageIdx, pages] = usePager(employees, duration * 1000, showCongratulations ? false : playing, 10);
  const Header = /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: text,
    metadata: metadata,
    description: description,
    isLeaderboard: true
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "employee-loyalty-leaderboard",
    style: containerStyle
  }, /*#__PURE__*/React.createElement(CongratulationsRunner, {
    color: accent_color,
    textColor: title_color,
    firstText: "CONGRATULATIONS!",
    secondText: topEmployeeName,
    header: Header,
    timeout: (duration - 5) * 1000,
    showCongratulations: playing && showCongratulations
  }, /*#__PURE__*/React.createElement("div", {
    className: "width-container"
  }, Header, /*#__PURE__*/React.createElement("div", {
    className: "product-sales-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-row list-header",
    style: listHeaderRowStyle
  }, /*#__PURE__*/React.createElement("p", {
    className: "employee_header"
  }, "Employee"), /*#__PURE__*/React.createElement("p", null, "Attachment")), page.map((employee, index) => {
    var _employee$name;
    return /*#__PURE__*/React.createElement(Row, {
      key: `${(_employee$name = employee.name) !== null && _employee$name !== void 0 ? _employee$name : employee.id}-${index}`,
      employee: employee,
      accent_color: accent_color,
      text: text
    });
  })), !showCongratulations && pages.length > 1 && /*#__PURE__*/React.createElement(PageIndicator, {
    pages: pages,
    current: pageIdx,
    selectedColor: accent_color
  })), /*#__PURE__*/React.createElement(SideBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    logo: metadata.logo,
    text: text.message_board,
    fontFamily: title_font_family,
    hide_poweredbyupshow: hide_poweredbyupshow
  })));
};
export default EmployeeLoyaltyLeaderboard;